import { IBwjBillboardProps } from "../../framework/components/bwj-billboard";
import { BwjButtonType } from "../../framework/components/bwj-button";

export const useStandardErrorState = () => {

  const props: IBwjBillboardProps = {
    icon: 'StatusErrorFull',
    graphicPortraitOriented: true,
    message: 'Sorry - an unexpected error occurred.  Please try reloading the app',
    buttons: [{
      buttonStyle: BwjButtonType.PrimaryStandard,
      text: 'Reload application',
      onClick: () => window.location.reload(),
    }],
  };

  return props;
}